import { useEffect, useState } from 'react';

import { useSearch } from '@backstage/plugin-search-react';
import AllIcon from '@material-ui/icons/FontDownload';
import { CatalogIcon, DocsIcon } from '@backstage/core-components';
import CustomSearchFilter from './CustomSearchFilter';
import { SearchAccordionProps } from './types';

/**
 * A component that provides a filter for the search results by type.
 * @param props - {@link SearchAccordionProps} for the component.
 * @public
 */
export const SearchTypesAccordion = (props: SearchAccordionProps) => {
  const { setTypes, types, setPageCursor } = useSearch();
  const { defaultValue, name } = props;
  const [expanded, setExpanded] = useState(true);
  const toggleExpanded = () => setExpanded(prevState => !prevState);

  const handleClick = (source: string) => {
    return () => {
      setTypes(source !== '' ? [source] : []);
      setPageCursor(undefined);
    };
  };

  // Handle any provided defaultValue
  useEffect(() => {
    if (defaultValue) {
      setTypes([defaultValue]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const definedSources = [
    {
      value: '',
      name: 'All',
      icon: <AllIcon />,
    },
    {
      value: 'software-catalog',
      name: 'Software Catalog',
      icon: <CatalogIcon />,
    },
    {
      value: 'techdocs',
      name: 'Documentation',
      icon: <DocsIcon />,
    },
  ];

  const selected = types[0] ?? definedSources[0].name;

  return (
    <CustomSearchFilter
      name={name}
      label="Filter by Type"
      accordionData={definedSources}
      selected={selected as string}
      onClick={handleClick}
      expanded={expanded}
      toggleExpanded={toggleExpanded}
    />
  );
};
